import { render, staticRenderFns } from "./component-img-txt.vue?vue&type=template&id=5ae629fd&scoped=true&"
import script from "./component-img-txt.vue?vue&type=script&lang=js&"
export * from "./component-img-txt.vue?vue&type=script&lang=js&"
import style0 from "./component-img-txt.vue?vue&type=style&index=0&id=5ae629fd&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae629fd",
  null
  
)

export default component.exports